import { IAlertTypeItemData } from "@home-health-notify/domain";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, TextField, Typography } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React from "react";
import { SubmitButton } from "../../addPatientGroup/AddPatientGroup.style";
import {
  ModalActions,
  ModalBody,
  ReferralModalContainer,
  ReferralModalHeader,
} from "./ReferralAlert.style";

interface ReferralRefusalModalProps {
  modalOpen: boolean;
  handleModalClose: () => void;
  modalData: IAlertTypeItemData;
  reasonOfRefusal: string;
  setReasonOfRefusal: (reason: string) => void;
  onRefuseReferral: (
    modalData: IAlertTypeItemData,
    reasonOfRefusal: string,
  ) => void;
  isSubmitting: boolean;
}

const ReferralRefusalModal = ({
  modalOpen,
  handleModalClose,
  reasonOfRefusal,
  setReasonOfRefusal,
  onRefuseReferral,
  modalData,
  isSubmitting,
}: ReferralRefusalModalProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        handleModalClose();
      }}
      aria-labelledby="referral-refuse-modal"
      data-testid="referral-refuse-modal"
    >
      <ReferralModalContainer>
        <ReferralModalHeader>
          <Typography variant="h6" color="white">
            {tNs("referral.refuseTitle")}{" "}
          </Typography>
          <CloseIcon
            style={{
              cursor: "pointer",
              color: "white",
              justifyContent: "flex-end",
            }}
            onClick={() => {
              handleModalClose();
            }}
            data-testid="modal-close-btn"
          />
        </ReferralModalHeader>
        <ModalBody>
          <TextField
            multiline={true}
            rows={2}
            required
            label={tNs("referral.reason")}
            variant="standard"
            sx={{ margin: "50px 20px 30px 20px" }}
            value={reasonOfRefusal}
            onChange={e => {
              setReasonOfRefusal(e.target.value);
            }}
            slotProps={{
              htmlInput: {
                "data-testid": "refusal-message-entry-field",
              },
            }}
          />
          <ModalActions>
            <SubmitButton
              variant="contained"
              onClick={() => {
                handleModalClose();
              }}
              style={{
                backgroundColor: "white",
                color: "black",
              }}
              data-testid="modal-cancel-btn"
            >
              {tNs("referral.cancel")}
            </SubmitButton>
            <SubmitButton
              variant="contained"
              onClick={() => onRefuseReferral(modalData, reasonOfRefusal)}
              disabled={!reasonOfRefusal.trim() || isSubmitting}
              data-testid="refusal-message-submit-btn"
            >
              {tNs("referral.submit")}
            </SubmitButton>
          </ModalActions>
        </ModalBody>
      </ReferralModalContainer>
    </Modal>
  );
};

export default ReferralRefusalModal;
